export const pl = {
  welcome: "Witamy w",
};
